var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { LocalizationContext } from '.';
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
export var withTranslations = function (Component) {
    var WithTranslations = function (props) { return (React.createElement(LocalizationContext.Consumer, null, function (context) { return (React.createElement(Component, __assign({}, props, { translations: context.translations, locale: context.locale }))); })); };
    WithTranslations.displayName = "WithTranslations(" + getDisplayName(Component) + ")";
    WithTranslations.propTypes = Component.propTypes;
    WithTranslations.defaultProps = Component.defaultProps;
    return WithTranslations;
};
//# sourceMappingURL=withTranslations.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ilenia/dist/withTranslations.js
// module id = 701
// module chunks = 0